import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { actions } from './Dialog';
import { pathname } from '../../../utils';
import Button from '@material-ui/core/Button';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';

const useStyles = makeStyles((theme: any) => ({
  continueButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: 175,
  },
}));

export default function PaymentRedirect({
  setOptionNumber,
  open,
  endRequest = null,
}) {
  const classes = useStyles();
  const header = 'Change a Remittance';

  const content = (
    <>
      <Typography>
        Please submit your request via your <b>{pathname.remittance.label}</b>{' '}
        tab, by clicking on the remittance you'd like to change and providing
        more information.
      </Typography>
    </>
  );

  const action = (
    <Button
      variant="contained"
      color="primary"
      className={classes.continueButton}
      onClick={() => setOptionNumber(actions.changePayment)}
    >
      <b>Go to {pathname.remittance.label}</b>
    </Button>
  );

  return (
    <Dialog
      open={open}
      header={header}
      children={content}
      actions={action}
      onClose={endRequest}
    />
  );
}
